import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.31 6.39H6.13V3.44a1.5 1.5 0 0 1 1.5-1.5h.75a1.5 1.5 0 0 1 1.5 1.5.75.75 0 0 0 1.5 0 3 3 0 0 0-3-3h-.75a3 3 0 0 0-3 3v2.95A2.75 2.75 0 0 0 2 9.14V12a2.75 2.75 0 0 0 2.7 2.75h6.61A2.75 2.75 0 0 0 14.06 12V9.14a2.75 2.75 0 0 0-2.75-2.75ZM12.56 12a1.25 1.25 0 0 1-1.25 1.25H4.7A1.25 1.25 0 0 1 3.45 12V9.14A1.25 1.25 0 0 1 4.7 7.89h6.61a1.25 1.25 0 0 1 1.25 1.25Z';
const draw24px =
  'M17.07,10.18H9.25V6A2.25,2.25,0,0,1,11.5,3.75h1A2.25,2.25,0,0,1,14.75,6a.75.75,0,0,0,1.5,0A3.75,3.75,0,0,0,12.5,2.25h-1A3.75,3.75,0,0,0,7.75,6v4.18H6.93a2.75,2.75,0,0,0-2.75,2.75v5.14a2.75,2.75,0,0,0,2.75,2.75H17.07a2.75,2.75,0,0,0,2.75-2.75V12.93A2.75,2.75,0,0,0,17.07,10.18Zm1.25,7.89a1.25,1.25,0,0,1-1.25,1.25H6.93a1.25,1.25,0,0,1-1.25-1.25V12.93a1.25,1.25,0,0,1,1.25-1.25H17.07a1.25,1.25,0,0,1,1.25,1.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LockUnlockIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'lockUnlock'),
) as IconWithRender;

LockUnlockIcon.displayName = 'LockUnlockIcon';
LockUnlockIcon.propTypes = Icon.propTypes;
LockUnlockIcon.renderIcon = (props) => <LockUnlockIcon {...props} />;
export default LockUnlockIcon;
